/**
 * rb-review.js — Ring Builder: Resumen y Confirmación
 * Lee diamante de sessionStorage, montura de Shopify /variants/{id}.js,
 * renderiza el layout de 3 columnas y maneja el add to cart.
 */

(function () {
  'use strict';

  var RING_SIZES = [
    '4', '4.5', '5', '5.5', '6', '6.5', '7', '7.5',
    '8', '8.5', '9', '9.5', '10', '10.5', '11'
  ];

  var cfg    = window.rbReviewConfig || {};
  var _params = new URLSearchParams(window.location.search);

  // Prefer Liquid-injected config; fall back to URL params directly (Liquid split can fail)
  var settingVariantId = (/^\d+$/.test(cfg.settingVariantId || ''))
    ? cfg.settingVariantId
    : (_params.get('setting') || '');
  var diamondVariantId = (/^\d+$/.test(cfg.diamondVariantId || ''))
    ? cfg.diamondVariantId
    : (_params.get('diamond') || '');

  console.log('[rb-review] cfg from Liquid:', cfg);
  console.log('[rb-review] URL params — setting:', _params.get('setting'), '| diamond:', _params.get('diamond'));
  console.log('[rb-review] Resolved — settingVariantId:', settingVariantId, '| diamondVariantId:', diamondVariantId);

  var diamond = null;
  var setting = null;

  // ── Init ────────────────────────────────────────────────────────────────────

  function init() {
    // Load diamond from sessionStorage
    try { diamond = JSON.parse(sessionStorage.getItem('diamore_diamond') || 'null'); } catch (e) {}

    // Load cached setting metadata (image, name, style)
    var cachedSetting = null;
    try { cachedSetting = JSON.parse(sessionStorage.getItem('diamore_setting') || 'null'); } catch (e) {}

    if (!diamond) {
      showError('Información del diamante no encontrada. Por favor <a href="/pages/ring-builder">empieza de nuevo</a>.');
      return;
    }
    if (!settingVariantId) {
      showError('Montura no especificada. Por favor <a href="/collections/monturas">elige una montura</a>.');
      return;
    }

    // Update back link with diamond context
    var backLink = document.getElementById('rb-back-link');
    if (backLink && diamondVariantId) {
      backLink.href = cfg.settingPageUrl + '?diamond=' + diamondVariantId;
    }

    // Fetch setting variant from Shopify Ajax API
    console.log('[rb-review] Fetching variant:', '/variants/' + settingVariantId + '.js');
    fetch('/variants/' + settingVariantId + '.js')
      .then(function (res) {
        console.log('[rb-review] Variant fetch status:', res.status, res.ok);
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.json();
      })
      .then(function (variant) {
        console.log('[rb-review] Variant data:', variant);
        setting = {
          variantId: variant.id,
          name:      variant.product_title || (cachedSetting && cachedSetting.name) || variant.title,
          style:     (cachedSetting && cachedSetting.style) || '',
          image:     (variant.featured_image && variant.featured_image.src)
                       || (cachedSetting && cachedSetting.image) || '',
          metal:     variant.option1 || 'WG14k',
          shape:     (cachedSetting && cachedSetting.shape) || (diamond && diamond.shape) || 'Round',
          price:     variant.price   // cents
        };
        renderReview();
      })
      .catch(function (err) {
        console.error('[rb-review] Variant fetch error:', err);
        // Fallback to cached setting data if available
        if (cachedSetting) {
          setting = {
            variantId: parseInt(settingVariantId, 10),
            name:      cachedSetting.name  || '',
            style:     cachedSetting.style || '',
            image:     cachedSetting.image || '',
            metal:     'WG14k',
            shape:     (diamond && diamond.shape) || 'Round',
            price:     0
          };
          renderReview();
        } else {
          showError('Error cargando datos de la montura. Por favor <a href="/collections/monturas">intenta de nuevo</a>.');
        }
      });
  }

  // ── Helpers ─────────────────────────────────────────────────────────────────

  function fmt$(n) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency', currency: 'USD',
      minimumFractionDigits: 0, maximumFractionDigits: 0
    }).format(n || 0);
  }

  function fmtCents(cents) {
    return fmt$((cents || 0) / 100);
  }

  function esc(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function escAttr(s) {
    if (s == null) return '';
    return String(s).replace(/&/g, '&amp;').replace(/'/g, '&#39;').replace(/"/g, '&quot;');
  }

  function isLabGrown(d) {
    // 1. stone_type (patched from sessionStorage on load)
    if (d.stone_type === 'lab') return true;
    if (d.stone_type === 'natural') return false;

    // 2. Prefijo del número de certificado IGI
    if (d.cert_number && d.cert_number.toString().startsWith('LG')) return true;

    // 3. Fallback
    if (d.labgrown === true) return true;

    return false;
  }

  function showError(msg) {
    var el = document.getElementById('rb-global-error');
    if (!el) return;
    el.innerHTML = msg;
    el.classList.remove('rb-hidden');
  }

  function showCartError(msg) {
    var el = document.getElementById('rb-cart-error');
    if (el) { el.textContent = msg; el.classList.remove('rb-hidden'); }
  }

  function diamondSvg() {
    return '<svg width="60" height="60" viewBox="0 0 60 60" fill="none" aria-hidden="true">'
      + '<polygon points="30,5 55,22 45,55 15,55 5,22" stroke="currentColor" stroke-width="1.5" fill="none" opacity="0.4"/>'
      + '<polygon points="30,5 55,22 30,18 5,22" stroke="currentColor" stroke-width="1.5" fill="none" opacity="0.3"/>'
      + '</svg>';
  }

  function renderDiamondMedia(d) {
    var imgSrc = d.image_url || d.img_url || d.image || d.thumbnail || '';
    var altText = 'Diamante ' + (d.carat || '') + 'ct';
    if (imgSrc) {
      return '<img src="' + esc(imgSrc) + '" alt="' + esc(altText) + '" loading="lazy">';
    }
    var videoSrc = d.video_360_url || d.video_url || '';
    if (videoSrc) {
      // Show muted looping video as image fallback
      return '<video src="' + esc(videoSrc) + '" autoplay muted loop playsinline'
        + ' class="rb-diamond-video-preview" aria-label="' + esc(altText) + '"></video>';
    }
    return '<div class="rb-card__image-placeholder rb-diamond-placeholder">' + diamondSvg() + '</div>';
  }

  // ── Render ───────────────────────────────────────────────────────────────────

  function renderReview() {
    var d = diamond;
    var s = setting;

    var settingPrice$ = (s.price || 0) / 100;      // Shopify price in cents
    var diamond$      = d.price_with_markup || 0;  // CF Worker returns USD
    var total$        = settingPrice$ + diamond$;
    var certStr       = ((d.cert_lab || '') + ' ' + (d.cert_number || '')).trim();
    var imgSrc        = d.image_url || d.img_url || d.image || d.thumbnail || '';

    // ── Col 1: Diamante ──
    var col1 = document.getElementById('rb-summary-diamond');
    if (col1) {
      var changeDiamondUrl = cfg.diamondPageUrl + (s.variantId ? '?setting=' + s.variantId : '');
      var eyeClean = d.eye_clean === 'Yes' || d.eyeClean === 'Yes';
      col1.innerHTML =
        '<div class="rb-review-eyebrow">Tu diamante</div>'
        + '<div class="rb-review-image-wrap">'
        + (imgSrc
          ? '<img src="' + esc(imgSrc) + '" alt="Diamante" loading="lazy"'
            + ' onerror="this.parentElement.style.background=\'#F5EDE8\'">'
          : '<div style="width:100%;height:100%;display:flex;align-items:center;'
            + 'justify-content:center;background:#F5EDE8;">' + diamondSvg() + '</div>')
        + '</div>'
        + '<div class="rb-review-title">'
        + esc((d.carat || '') + 'ct · ' + (d.color || '') + ' · ' + (d.clarity || ''))
        + '</div>'
        + '<div class="rb-review-subtitle">'
        + esc((d.shape || '') + (certStr ? ' · ' + certStr : '') + ' · '
          + (isLabGrown(d) ? 'Lab-Grown' : 'Natural'))
        + '</div>'
        + '<div class="rb-review-badges">'
        + '<span class="rb-badge rb-badge--burg">'
        + esc(isLabGrown(d) ? 'Lab-Grown' : 'Natural') + '</span>'
        + (eyeClean ? '<span class="rb-badge rb-badge--out">Eye Clean</span>' : '')
        + '</div>'
        + '<div class="rb-review-specs">'
        + '<div class="rb-spec"><span class="rb-spec-label">Color</span>'
        + '<span class="rb-spec-value">' + esc(d.color || '') + '</span></div>'
        + '<div class="rb-spec"><span class="rb-spec-label">Claridad</span>'
        + '<span class="rb-spec-value">' + esc(d.clarity || '') + '</span></div>'
        + '<div class="rb-spec"><span class="rb-spec-label">Corte</span>'
        + '<span class="rb-spec-value">' + esc(d.cut || '') + '</span></div>'
        + '<div class="rb-spec"><span class="rb-spec-label">Certificado</span>'
        + '<span class="rb-spec-value">' + esc(certStr) + '</span></div>'
        + '</div>'
        + '<div class="rb-review-price">' + fmt$(diamond$) + '</div>'
        + '<button class="rb-review-change"'
        + ' onclick="window.location.href=\'' + escAttr(changeDiamondUrl) + '\'">'
        + 'Cambiar diamante</button>';
    }

    // ── Col 2: Montura ──
    var col2 = document.getElementById('rb-summary-setting');
    if (col2) {
      var changeSetting = cfg.settingPageUrl + (diamondVariantId ? '?diamond=' + diamondVariantId : '');
      col2.innerHTML =
        '<div class="rb-review-eyebrow">Tu montura</div>'
        + '<div class="rb-review-image-wrap">'
        + (s.image
          ? '<img src="' + esc(s.image) + '" alt="Montura" loading="lazy"'
            + ' onerror="this.parentElement.style.background=\'#F5EDE8\'">'
          : '<div style="width:100%;height:100%;background:#F5EDE8;"></div>')
        + '</div>'
        + '<div class="rb-review-title">' + esc(s.name || '') + '</div>'
        + '<div class="rb-review-subtitle">'
        + esc((s.metal || '') + (s.shape ? ' · ' + s.shape : ''))
        + '</div>'
        + '<div class="rb-review-badges">'
        + (s.metal ? '<span class="rb-badge rb-badge--out">' + esc(s.metal) + '</span>' : '')
        + (s.shape ? '<span class="rb-badge rb-badge--out">' + esc(s.shape) + '</span>' : '')
        + '</div>'
        + '<div class="rb-review-specs">'
        + '<div class="rb-spec"><span class="rb-spec-label">Metal</span>'
        + '<span class="rb-spec-value">' + esc(s.metal || '') + '</span></div>'
        + '<div class="rb-spec"><span class="rb-spec-label">Forma</span>'
        + '<span class="rb-spec-value">' + esc(s.shape || '') + '</span></div>'
        + '<div class="rb-spec"><span class="rb-spec-label">Estilo</span>'
        + '<span class="rb-spec-value">' + esc(s.style || 'Solitario') + '</span></div>'
        + '<div class="rb-spec"><span class="rb-spec-label">Origen</span>'
        + '<span class="rb-spec-value">Lab-Grown</span></div>'
        + '</div>'
        + '<div class="rb-review-price">' + fmtCents(s.price) + '</div>'
        + '<button class="rb-review-change"'
        + ' onclick="window.location.href=\'' + escAttr(changeSetting) + '\'">'
        + 'Cambiar montura</button>';
    }

    // ── Col 3: Total + CTA ──
    var col3 = document.getElementById('rb-summary-total');
    if (col3) {
      var sizeOptions = RING_SIZES.map(function (sz) {
        return '<option value="' + sz + '">' + sz + '</option>';
      }).join('');

      col3.innerHTML =
        '<div class="rb-total-eyebrow">Tu anillo personalizado</div>'
        + '<div class="rb-total-price">' + fmt$(total$) + '</div>'
        + '<div class="rb-total-subtitle">USD · Envío gratis a Panamá</div>'
        + '<div class="rb-total-breakdown">'
        + '<div class="rb-breakdown-row"><span>Diamante</span><span>' + fmt$(diamond$) + '</span></div>'
        + '<div class="rb-breakdown-row"><span>Montura</span><span>' + fmtCents(s.price) + '</span></div>'
        + '<div class="rb-breakdown-row"><span>Envío</span><span>Gratis</span></div>'
        + '</div>'
        + '<div class="rb-size-section">'
        + '<label class="rb-size-label" for="rb-size-select">Talla del anillo</label>'
        + '<select id="rb-size-select" class="rb-ring-size-select" aria-label="Talla del anillo">'
        + '<option value="">Selecciona tu talla</option>'
        + sizeOptions
        + '</select>'
        + '</div>'
        + '<button id="rb-add-to-cart" class="rb-cta-primary">✦ Agregar al carrito</button>'
        + '<button id="rb-consult-btn" class="rb-cta-secondary">Reservar consulta presencial</button>'
        + '<div id="rb-cart-error" class="rb-cart-error rb-hidden" role="alert"></div>'
        + '<div class="rb-trust-row">'
        + '<div>Garantía<br>de por vida</div>'
        + '<div>Envío<br>asegurado</div>'
        + '<div>Pago<br>seguro</div>'
        + '</div>';

      document.getElementById('rb-add-to-cart').addEventListener('click', addToCart);
      var consultBtn = document.getElementById('rb-consult-btn');
      if (consultBtn) consultBtn.addEventListener('click', function () {
        window.location.href = '/pages/reservar-cita';
      });
    }

    // Mobile: reorder blocks so CTA is at top
    if (window.innerWidth <= 767) {
      reorganizeReviewMobile(d, s, diamond$, settingPrice$, total$);
    }
  }

  function reorganizeReviewMobile(d, s, diamond$, settingPrice$, total$) {
    var layout = document.querySelector('.rb-summary-layout');
    if (!layout) return;

    var sizeOptions = RING_SIZES.map(function (sz) {
      return '<option value="' + sz + '">' + sz + '</option>';
    }).join('');

    // BLOQUE 1: Total + desglose + talla + CTAs (fondo burgundy)
    var block1 = document.createElement('div');
    block1.className = 'rb-mobile-checkout-block';
    block1.innerHTML =
      '<div class="rb-mobile-total-label">Tu anillo personalizado</div>'
      + '<div class="rb-mobile-total-row">'
      +   '<div>'
      +     '<div class="rb-mobile-total-sublabel">Total</div>'
      +     '<div class="rb-mobile-total-price">' + fmt$(total$) + '</div>'
      +   '</div>'
      +   '<div class="rb-mobile-shipping">'
      +     '<div>Envío</div>'
      +     '<div>Gratis · Panamá</div>'
      +   '</div>'
      + '</div>'
      + '<div class="rb-mobile-breakdown-inner">'
      +   '<div class="rb-mobile-breakdown-row">'
      +     '<span>Diamante</span><span>' + fmt$(diamond$) + '</span>'
      +   '</div>'
      +   '<div class="rb-mobile-breakdown-row">'
      +     '<span>Montura</span><span>' + fmt$(settingPrice$) + '</span>'
      +   '</div>'
      + '</div>'
      + '<div class="rb-ring-size-section">'
      +   '<label for="rb-size-select" class="rb-ring-size-label">TALLA DEL ANILLO (US)</label>'
      +   '<select id="rb-size-select" class="rb-ring-size-select" aria-label="Talla del anillo">'
      +   '<option value="">Selecciona tu talla</option>'
      +   sizeOptions
      +   '</select>'
      + '</div>'
      + '<button id="rb-add-to-cart" class="rb-add-to-cart-btn">AGREGAR AL CARRITO →</button>'
      + '<button id="rb-consult-btn" class="rb-consult-btn">RESERVAR CONSULTA PRESENCIAL</button>'
      + '<div id="rb-cart-error" class="rb-cart-error rb-hidden" role="alert"></div>';

    // BLOQUE 2: Cards de detalle + trust — HTML explícito para altura uniforme
    var diamondImgSrc = d.image_url || d.img_url || d.image || d.thumbnail || '';
    var certStr = ((d.cert_lab || '') + (d.cert_number ? ' ' + d.cert_number : '')).trim();
    var block3 = document.createElement('div');
    block3.className = 'rb-mobile-details';
    block3.innerHTML = `
  <div class="rb-mobile-details-label">Detalles de tu selección</div>

  <div class="rb-mobile-detail-card">
    <div class="rb-mobile-detail-img">
      <img src="${esc(diamondImgSrc)}"
           alt="Diamante"
           onerror="this.parentElement.style.background='#F5EDE8'">
    </div>
    <div class="rb-mobile-detail-info">
      <div class="rb-mobile-detail-type">Diamante</div>
      <div class="rb-mobile-detail-title">
        ${esc((d.carat || '') + 'ct · ' + (d.color || '') + ' · ' + (d.clarity || '') + ' · ' + (d.shape || ''))}
      </div>
      <div class="rb-mobile-detail-sub">
        ${esc((d.cut || '') + (certStr ? ' · ' + certStr : '') + (isLabGrown(d) ? ' · Lab-Grown' : ' · Natural'))}
      </div>
    </div>
    <button class="rb-mobile-detail-change"
            onclick="window.location.href='/pages/ring-builder-diamond'">
      Cambiar
    </button>
  </div>

  <div class="rb-mobile-detail-card">
    <div class="rb-mobile-detail-img">
      <img src="${esc(s.image || '')}"
           alt="Montura"
           onerror="this.parentElement.style.background='#F0E4DC'">
    </div>
    <div class="rb-mobile-detail-info">
      <div class="rb-mobile-detail-type">Montura</div>
      <div class="rb-mobile-detail-title">${esc(s.name || '')}</div>
      <div class="rb-mobile-detail-sub">${esc(s.metal || '')}</div>
    </div>
    <button class="rb-mobile-detail-change"
            onclick="window.location.href='/collections/monturas'">
      Cambiar
    </button>
  </div>

  <div class="rb-mobile-trust">
    <div>Garantía<br>de por vida</div>
    <div>Envío<br>asegurado</div>
    <div>Pago<br>seguro</div>
  </div>
`;

    // Replace layout
    layout.innerHTML = '';
    layout.appendChild(block1);
    layout.appendChild(block3);

    // Re-attach event listeners to new elements
    var newCartBtn = document.getElementById('rb-add-to-cart');
    if (newCartBtn) newCartBtn.addEventListener('click', addToCart);

    var newConsultBtn = document.getElementById('rb-consult-btn');
    if (newConsultBtn) newConsultBtn.addEventListener('click', function () {
      window.location.href = '/pages/reservar-cita';
    });
  }

  function toggleVideo(container, videoUrl, btn) {
    if (container.classList.contains('rb-hidden')) {
      container.classList.remove('rb-hidden');
      if (!container.querySelector('iframe')) {
        var iframe = document.createElement('iframe');
        iframe.src = videoUrl;
        iframe.className = 'rb-diamond-video-frame';
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'autoplay; fullscreen');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', 'Video 360°');
        container.appendChild(iframe);
      }
      if (btn) btn.classList.add('rb-diamond-video-btn--active');
    } else {
      container.classList.add('rb-hidden');
      if (btn) btn.classList.remove('rb-diamond-video-btn--active');
    }
  }

  // ── Add to Cart ──────────────────────────────────────────────────────────────

  async function addToCart() {
    const btn = document.getElementById('rb-add-to-cart');
    const sizeSelect = document.getElementById('rb-size-select');

    // Validar talla
    const selectedSize = sizeSelect ? sizeSelect.value : '';
    if (!selectedSize) {
      sizeSelect.style.border = '2px solid #E24B4A';
      sizeSelect.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    // Validar setting y diamante
    if (!settingVariantId) {
      window.location.href = '/collections/monturas';
      return;
    }
    const diamond = JSON.parse(sessionStorage.getItem('diamore_diamond') || 'null');
    if (!diamond) {
      window.location.href = '/pages/ring-builder-diamond';
      return;
    }

    // Patch stone_type from sessionStorage if not present on diamond object
    if (!diamond.stone_type) {
      diamond.stone_type = sessionStorage.getItem('diamore_stone_type') || 'natural';
    }

    // UI feedback
    if (btn) { btn.textContent = 'Preparando tu anillo...'; btn.disabled = true; }

    try {
      // PASO 1: Crear / recuperar producto de diamante en Shopify
      const cfUrl = cfg.cfWorkerUrl || 'https://diamore-proxy.diamorejoyeros.workers.dev';

      // Check sessionStorage cache to avoid duplicate CF Worker calls
      const cacheKey = 'diamore_product_' + (diamond.cert_number || diamond.id);
      let createData = null;
      try {
        const cached = sessionStorage.getItem(cacheKey);
        if (cached) {
          createData = JSON.parse(cached);
          console.log('[rb-review] Using cached diamond product:', createData.variantId);
        }
      } catch (e) {}

      if (!createData) {
        const createResponse = await fetch(cfUrl + '/diamond/create-product', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ diamond })
        });

        if (!createResponse.ok) {
          const errBody = await createResponse.text();
          throw new Error('No se pudo crear el producto del diamante: ' + errBody);
        }

        createData = await createResponse.json();
        console.log('[rb-review] Create product response:', JSON.stringify(createData));

        // Cache the result for this session
        try { sessionStorage.setItem(cacheKey, JSON.stringify(createData)); } catch (e) {}
      }

      console.log('[rb-review] Diamond variant ID:', createData.variantId);

      const createdVariantId = createData.variantId;
      if (!createdVariantId) throw new Error('Respuesta inválida del servidor (variantId ausente). Respuesta: ' + JSON.stringify(createData));

      // PASO 2: Agregar montura + diamante al carrito
      const certStr = ((diamond.cert_lab || '') + ' ' + (diamond.cert_number || '')).trim();

      const cartPayload = {
        items: [
          {
            id: parseInt(settingVariantId, 10),
            quantity: 1,
            properties: {
              'Talla': selectedSize,
              '_diamond_id': diamond.id
            }
          },
          {
            id: createdVariantId,
            quantity: 1,
            properties: {
              'Quilates': String(diamond.carat || ''),
              'Color': diamond.color || '',
              'Claridad': diamond.clarity || '',
              'Corte': diamond.cut || '',
              'Certificado': certStr,
              'Forma': diamond.shape || '',
              'Tipo': isLabGrown(diamond) ? 'Lab-Grown' : 'Natural'
            }
          }
        ]
      };
      console.log('[rb-review] Cart payload:', JSON.stringify(cartPayload));

      const cartResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(cartPayload)
      });

      const cartData = await cartResponse.json();
      console.log('[rb-review] Cart response status:', cartResponse.status, '| data:', JSON.stringify(cartData));

      if (!cartResponse.ok || cartData.status) {
        throw new Error(cartData.description || cartData.message || 'Error al agregar al carrito');
      }

      // PASO 3: Ir al carrito
      window.location.href = '/cart';

    } catch (err) {
      if (btn) {
        btn.textContent = 'AGREGAR AL CARRITO →';
        btn.disabled = false;
      }
      const errMsg = document.createElement('p');
      errMsg.style.cssText = 'color:#E24B4A;padding:10px 0;font-size:13px;text-align:center;';
      errMsg.textContent = 'Error: ' + err.message;
      if (btn && btn.parentNode) btn.parentNode.insertBefore(errMsg, btn);
    }
  }

  // ── Boot ─────────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
